import * as React from "react";
const IconDoorAlt = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M41.1 27.3c-2.4 0-4.4 2-4.4 4.4s2 4.4 4.4 4.4 4.4-2 4.4-4.4-1.9-4.4-4.4-4.4m0 6.8c-1.3 0-2.4-1.1-2.4-2.4s1.1-2.4 2.4-2.4 2.4 1.1 2.4 2.4-1 2.4-2.4 2.4" />
    <path d="M61 60h-6.9V7c0-2.8-2.2-5-5-5H14.9c-2.8 0-5 2.2-5 5v53H3c-.6 0-1 .4-1 1s.4 1 1 1h58c.6 0 1-.4 1-1s-.4-1-1-1m-49.1 0V7c0-1.7 1.3-3 3-3h34.2c1.7 0 3 1.3 3 3v53z" />
  </svg>
);
export default IconDoorAlt;
